export const CONTACT_TYPES = [
    { value: 'Sales support', label: 'Sales support' },
    { value: 'Technical support', label: 'Technical support' },
    { value: 'Incidents support', label: 'Incidents support' },
];
